import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { WaremaPlusCompanySearchDataAccessModule } from '@warema/shared/company-search/data-access';

@NgModule({
    imports: [CommonModule, WaremaPlusCompanySearchDataAccessModule],
})
export class WaremaPlusCompanySearchApiModule {}
